var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row banks__list" },
    _vm._l(_vm.data.payment_list, function (item) {
      return _c("div", { staticClass: "bank__column" }, [
        _c(
          "label",
          {
            staticClass: "bank__item flex-column",
            class: { "bank__item--active": item.id === _vm.selectedOption },
          },
          [
            _c("img", {
              staticClass: "bank__item__image",
              attrs: { alt: "payment method logo", src: item.imageUrl },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "mb-0 bank__item__name" }, [
              _c(
                "span",
                {
                  staticClass:
                    "heading__desc font__family--gotham font__weight--light font__color--white",
                },
                [_vm._v(_vm._s(item.name))]
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedOption,
                  expression: "selectedOption",
                },
              ],
              staticClass: "bank__item__input d-none",
              attrs: { type: "radio" },
              domProps: {
                value: item.id,
                checked: _vm._q(_vm.selectedOption, item.id),
              },
              on: {
                change: function ($event) {
                  _vm.selectedOption = item.id
                },
              },
            }),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }